export const NAVBAR: {
	id: number;
	name: string;
	to: string;
	target?: string;
	src?: string;
}[] = [
	/*{
		id: 0,
		name: 'Atlas on Move',
		//src: '/crypto/movement.svg',
		to: 'https://atlas.rndm.io',
		target: '_blank',
	},*/
	{
		id: 1,
		name: '',
		src: '/crypto/movement.svg',
		to: 'https://movementlabs.xyz/',
		target: '_blank',
	},
	{
		id: 2,
		name: 'Contract Audit',
		to: 'http://movebit.xyz/reports/20241230-RNDM-Final-Audit-Report.pdf',
		target: '_blank',
	},
	/*	{
		id: 0,
		name: 'Docs',
		to: 'https://docs-dudu.rndm.io',
	},*/
	/*{
		id: 0,
		name: 'How it works',
		to: 'https://docs-dudu.rndm.io/how-to-use-dudu-ai-agent-vault',
		target: '_blank',
	},*/
	/*{
		id: 1,
		name: 'Insights',
		to: '/markets',
		target: undefined,
	},*/
	/*{
		id: 1,
		name: 'Terms and Conditions',
		to: '/terms-and-condition',
	},*/
	/*{
		id: 1,
		name: 'Positions',
		to: '/positions',
	},*/
];
